import { render, staticRenderFns } from "./SubLibraryCard.vue?vue&type=template&id=f66a545c"
import script from "./SubLibraryCard.vue?vue&type=script&lang=js"
export * from "./SubLibraryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports